<template>
  <div :class="containerClass" ref="container" v-click-outside="clickOutside">
    <div :class="anchorClass" :style="computedAnchorStyle">
      <div ref="tooltip" class="lego-tooltip-wrapper" :style="computedTooltipStyle">
        <div :style="customStyle" v-if="!$slots.tooltip" :class="tooltipClass" ref="tooltipContent">
          <!--
                    $ver: v0.1.0
                    툴팁내 위치할 컨텐츠 영역입니다. 일반적으로 문자열이 위치합니다.
                    #The content area to place in the tooltip. Typically the string is located.
                 --><slot />
          <lego-icon v-show="closeIconShow" class="lego-tooltip__close" size="16px" @click="close"
            >close</lego-icon
          >
        </div>
        <!--
                    $ver: v0.1.0
                    툴팁내 위치할 컨텐츠 영역입니다. tooltip으로 슬롯을 지정하여 사용할 수 있습니다. 일반적으로 문자열이 위치합니다.
                    #The content area to place in the tooltip. You can use the tooltip by specifying the slot. Typically the string is located.
                 -->
        <slot name="tooltip" />
      </div>
    </div>
  </div>
</template>

<script>
import legoEventBus from '@/lego-component/utils/eventBus/eventBus';

export default {
  name: 'lego-tooltip-extend-v-2',
  props: {
    customStyle: {
      type: String,
      default: ''
    },
    delayTime: {
      type: Number,
      default: 500
    },
    tooltipAlignment: {
      type: String,
      default: 'left'
    },
    leftAlign: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      timeoutID: undefined
    };
  },
  mounted() {
    this.$nextTick(() => {
      // 1. find target element
      if (typeof this.targetId === 'string' && this.targetId[0] === '#') {
        this.targetEl = document.getElementById(this.targetId.slice(1));
      } else if (this.targetId) {
        this.targetEl = document.getElementById(this.targetId);
      } else {
        this.targetEl = this.$el.previousElementSibling;
      }
      // 2. regist event
      if (this.$_hover) {
        // case.1 mouse-over 모드
        const elTagName = this.targetEl.tagName || '';
        this.targetEl.addEventListener(
          'mouseenter',
          (e) => {
            if (e.target.tagName !== elTagName) return;
            this.clickTrigger(e);
          },
          true
        ); /* not MOUSE-OVER */
        this.targetEl.addEventListener(
          'mouseleave',
          (e) => {
            if (e.target.tagName !== elTagName) return;
            this.close();
          },
          true
        ); /* not MOUSE-OUT */
        legoEventBus.$on('close_tooltips', this.clickOutside);
        // 고민중 : 마우스를 올리면 켜지는데, 그상태에서 클릭하면 꺼짐.
        //          클릭으로 켜지진 않는데 꺼짐 기능을 구지 없앨 이유가 있을까?
      } else {
        // case.2 Click 모드
        this.targetEl.addEventListener('click', this.clickTrigger);
        legoEventBus.$on('close_tooltips', this.clickOutside);
      }
    });
  },
  methods: {
    clickTrigger(e) {
      e.stopPropagation();
      if (this.showToggle === true || !this.$refs.tooltip) {
        this.clickOutside();
        return;
      }
      let contentContainer = this.targetEl.parentElement;
      let matchFuncName = contentContainer['matches'] ? 'matches' : 'msMatchesSelector';
      if (
        !(
          this.$el.parentElement &&
          this.$el.parentElement[matchFuncName]('.lego-tooltip-outer-invisible-container')
        )
      ) {
        while (
          contentContainer &&
          !(
            contentContainer[matchFuncName](this.contentContainer) ||
            contentContainer.classList.contains('lego-screen')
          )
        ) {
          contentContainer = contentContainer.parentElement || undefined;
        }
        if (!contentContainer) {
          contentContainer = document.body;
        }
        let childNodes = contentContainer.children;
        let outerContainer;
        for (let node of childNodes) {
          if (node.classList.contains('lego-tooltip-outer-invisible-container')) {
            outerContainer = node;
            break;
          }
        }
        if (!outerContainer) {
          outerContainer = document.createElement('div');
          outerContainer.className = 'lego-tooltip-outer-invisible-container';
          contentContainer.insertBefore(outerContainer, contentContainer.firstChild);
          outerContainer.appendChild(this.$el);
        } else {
          outerContainer.appendChild(this.$el);
        }
      } else {
        contentContainer = this.$el.parentElement.parentElement;
      }
      let scrollContainer = contentContainer;
      while (
        scrollContainer &&
        !(
          scrollContainer[matchFuncName](this.scrollContainer) ||
          scrollContainer.classList.contains('lego-system')
        )
      ) {
        scrollContainer = scrollContainer.parentElement || undefined;
      }
      if (!scrollContainer) {
        scrollContainer = document.body;
      }

      let positionLimit = scrollContainer.getBoundingClientRect();
      let target = this.targetEl.getBoundingClientRect();
      let container = this.$el.getBoundingClientRect();
      let tooltip = this.$refs.tooltip.getBoundingClientRect();
      let arrowWidth = !this.$slots.tooltip ? 9 : 0;

      this.computedAnchorStyle = this.getAnchorStyle(
        positionLimit,
        target,
        container,
        tooltip,
        arrowWidth
      );
      this.computedTooltipStyle = this.getToolTipStyle(positionLimit, target, tooltip, arrowWidth);

      // To replace "width: max-content" in IE
      if (this.$refs.tooltipContent.offsetWidth < this.$refs.tooltipContent.scrollWidth) {
        this.$refs.tooltipContent.style.width = this.maxWidth + 'px';
        this.multiline = true;
      }

      this.open();
    },
    getToolTipStyle(parent, target, tooltip, arrowWidth) {
      let tooltipStyle = {};
      if (this.location === 'left') {
        tooltipStyle.right = arrowWidth + 'px';
        if ((target.top + target.bottom) / 2 + tooltip.height - 12 > parent.bottom) {
          tooltipStyle.bottom = (target.top + target.bottom) / 2 - parent.bottom + 'px';
        } else {
          tooltipStyle.top = '-14px';
        }
      } else if (this.location === 'right') {
        tooltipStyle.left = arrowWidth + 'px';
        if ((target.top + target.bottom) / 2 + tooltip.height - 12 > parent.bottom) {
          tooltipStyle.bottom = (target.top + target.bottom) / 2 - parent.bottom + 'px';
        } else {
          tooltipStyle.top = '-14px';
        }
      } else if (this.location === 'top') {
        tooltipStyle.bottom = arrowWidth + 'px';
        if ((target.left + target.right) / 2 - tooltip.width / 2 < parent.left) {
          tooltipStyle.left = parent.left - (target.left + target.right) / 2 + 'px';
        } else if ((target.left + target.right) / 2 + tooltip.width / 2 > parent.right) {
          tooltipStyle.right = (target.left + target.right) / 2 - parent.right + 'px';
        } else {
          if (this.tooltipAlignment === 'center' || target.width > tooltip.width) {
            tooltipStyle.left = -tooltip.width / 2 + 'px';
          } else {
            tooltipStyle.left = -target.width / 2 - this.leftAlign + 'px';
          }
        }
      } else {
        tooltipStyle.top = arrowWidth + 'px';
        if ((target.left + target.right) / 2 - tooltip.width / 2 < parent.left) {
          tooltipStyle.left = parent.left - (target.left + target.right) / 2 + 'px';
        } else if ((target.left + target.right) / 2 + tooltip.width / 2 > parent.right) {
          tooltipStyle.right = (target.left + target.right) / 2 - parent.right + 'px';
        } else {
          tooltipStyle.left = -tooltip.width / 2 + 'px';
        }
      }
      return tooltipStyle;
    },
    open() {
      // $ver: v0.1.0
      // $arg: N/A
      // 툴팁이 펼쳐질 때, 다른 툴팁들을 닫는 이벤트를 발생시킵니다.
      // #When a tooltip is expanded, it raises an event that closes other tooltips.
      legoEventBus.$emit('close_tooltips');
      this.timeoutID = setTimeout(() => {
        this.showToggle = true;
      }, this.delayTime);
    },
    close() {
      this.showToggle = false;
      clearTimeout(this.timeoutID);
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-tooltip {
  border: 1px solid $color--ui-01;
  padding: 6px 10px;
  line-height: 18px;
  width: max-content;
  white-space: pre-wrap;
  border-radius: 4px;
  display: block;
  max-width: 350px;
}
.lego-tooltip-anchor__arrow--right::before {
  left: 1px;
}
.lego-tooltip-anchor__arrow--left::before {
  right: 1px;
}
.lego-tooltip-anchor__arrow--top::before {
  bottom: 1px;
}
.lego-tooltip-anchor__arrow--bottom::before {
  top: 1px;
}
.lego-tooltip-anchor::before {
  z-index: 1001;
}
*[tooltip]:hover::after {
  line-height: 26px;
  background-color: $color--ui-01;
  max-width: $lego-tooltip__max-width;
  padding: 0 8px;
  font-style: normal;
}
</style>
